import { formatarData } from '@/lib/formato';
import { situacaoCertificado } from '@/lib/situacao-certificado';
import { type EmpresaDetalhe } from '@fiscoai/contracts';

/** A captura usa o A1: sem ele (ou vencido) ela não liga. `null` quando está tudo certo. */
export function motivoSemCertificado(empresa: EmpresaDetalhe): string | null {
  const c = empresa.certificado;
  const s = situacaoCertificado(c?.validoAte ?? null);
  if (!c || s.tipo === 'SEM') return 'Envie o certificado A1 da empresa para ligar a captura.';
  if (s.tipo === 'VENCIDO')
    return `O certificado A1 venceu em ${formatarData(c.validoAte)}. Envie um novo para a captura voltar a consultar.`;
  return null;
}
